module.exports = __webpack_public_path__ + "img/DSC_0035-weiss.79bf4a1a.png";